import { render, staticRenderFns } from "./product-edit.vue?vue&type=template&id=a0db5c50&scoped=true&"
import script from "./product-edit.vue?vue&type=script&lang=js&"
export * from "./product-edit.vue?vue&type=script&lang=js&"
import style0 from "./product-edit.vue?vue&type=style&index=0&id=a0db5c50&prod&lang=scss&"
import style1 from "./product-edit.vue?vue&type=style&index=1&id=a0db5c50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0db5c50",
  null
  
)

export default component.exports